import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

/**
 * Shared form for Add / Edit Blog Category.
 * Purely presentational — no API calls inside.
 */
const BlogCategoryForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title = "Blog Category",
    submitLabel = "Save Category",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "switch") {
                    return (
                        <Switch
                            key={field.name}
                            values={values[field.name]}
                            handleChange={handleChange}
                            field={field}
                            ValueOne="1"
                            ValueTwo="0"
                            LabelOne="Active"
                            LabelTwo="Inactive"
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label={submitLabel}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default BlogCategoryForm;
